import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";

export async function getSchoolImageURL(schoolId: string): Promise<string> {
    const schoolRef = ref(storage, `SchoolProfiles/${schoolId}`);
    return await getDownloadURL(schoolRef).catch((error) => {
        return "";
    });
}

export async function uploadSchoolImage(schoolId: string, file: File): Promise<void> {
    const schoolRef = ref(storage, `SchoolProfiles/${schoolId}`);
    const metadata = {
        contentType: 'image/.*'
    };

    await uploadBytes(schoolRef, file, metadata);
}